import { EPermissoes } from '@/enums/ePermissoes';
import cadastro from './cadastro/routes';
import relatorios from './relatorios/routes';

const withTipoFornecimento = (routes: any[], utlTipoFornecimentoId: number): any[] =>
  routes.map((route) => ({
    ...route,
    meta: {
      ...route.meta,
      utlTipoFornecimentoId
    },
    children: route.children ? withTipoFornecimento(route.children, utlTipoFornecimentoId) : route.children
  }));

const routes = [
  {
    description: '4. Laudo de Bloco',
    path: 'laudo',
    name: 'laudoBloco',
    component: () => import('@/views/controle-tecnologico/laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'Bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Laudo de Bloco',
    path: 'laudo/incluir/:tipoEnsaioId/:laboratorioId',
    name: 'laudoinsertBloco',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoBloco',
      utlTipoFornecimentoId: 301,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Edição de Laudo de Bloco',
    path: 'laudo/editar/:id/:tipoEnsaioId/:laboratorioId',
    name: 'laudoUpdateBloco',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoBloco',
      utlTipoFornecimentoId: 301,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Revisão de Laudo de Bloco',
    path: 'revisao-laudo',
    name: 'revisaolaudoBloco',
    component: () => import('@/views/controle-tecnologico/aprovacao-laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Aprovacao_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: '1. Recebimento de Bloco',
    path: 'recebimento',
    name: 'recebimentobloco',
    component: () => import('@/views/utilidade/recebimento/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Recebimento de Bloco',
    path: 'recebimento/incluir',
    name: 'recebimentoblocoinsert',
    component: () => import('@/views/utilidade/recebimento/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Recebimento de Bloco',
    path: 'recebimento/editar/:id',
    name: 'recebimentoblocoupdate',
    component: () => import('@/views/utilidade/recebimento/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Recebimento],
      grupos: []
    },
    goesToMenu: false
  },
  {
    description: '2. Aplicação de Bloco',
    path: 'aplicacao',
    name: 'aplicacaobloco',
    component: () => import('@/views/utilidade/aplicacao-ambiente/Index.vue'),
    meta: {
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Aplicacao],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Aplicação de Bloco',
    path: 'aplicacao/incluir',
    name: 'inclusaoaplicacaobloco',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Aplicação de Bloco',
    path: 'aplicacao/editar/:protocolo',
    name: 'aplicacaoblocoupdate',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: '3. Ensaio de Bloco',
    path: 'ensaio',
    name: 'ensaiobloco',
    component: () => import('@/views/utilidade/ensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão/Edição de Ensaio de Bloco',
    path: 'ensaio/incluir',
    name: 'InclusaoEdicaoEnsaioBloco',
    component: () => import('@/views/utilidade/ensaio/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'ensaiobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios]
    }
  },
  {
    description: 'Estoque de Bloco',
    path: 'estoque',
    name: 'estoquebloco',
    component: () => import('@/views/utilidade/estoque/Index.vue'),
    meta: {
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Estoque],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Lote de Bloco',
    path: 'lote',
    name: 'produtofornecedorlotebloco',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Lote de Bloco',
    path: 'lote/incluir?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorloteblocoinsert',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorlotebloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Lote de Bloco',
    path: 'lote/editar/:id?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorloteblocoupdate',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorlotebloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    path: 'cadastro',
    description: 'Cadastro',
    goesToMenu: false,
    children: cadastro
  },
  {
    path: 'relatorios',
    description: 'Relatórios',
    goesToMenu: false,
    children: relatorios
  }
];

export default [
  {
    path: 'bloco',
    description: 'Bloco',
    meta: {
      utlTipoFornecimentoId: 301
    },
    goesToMenu: false,
    children: withTipoFornecimento(routes, 301)
  }
];
